export const doc_subscriptions_es = {
  title: "Suscripciones",
  home_title: "Cómo funcionan las suscripciones",
  description: `Para mantener Piper actualizado y libre de publicidad dependemos de nuestros sistemas de compras y suscripciones. Todos los usuarios pueden usar Piper de forma gratuita con ciertas limitaciones y pueden optar por uno de nuestros planes disponibles para apoyar a la aplicación y acceder a nuevas funcionalidades.
  
  Podés elegir entre estos 3 planes que tenemos disponibles:
  
  `,
  free_plan: "Plan gratuito: ",
  free_plan_description: `El plan gratuito te permite seguir usando Piper con normalidad, pero no vas a tener acceso a las funcionalidades adicionales de otros planes de suscripción.
  
  `,
  collector_plan: "Plan Coleccionista: ",
  collector_plan_description: `No incluye funcionalidades adicionales. Con la suscripción de 'Coleccionista' vas a estar ayudando a que Piper crezca y siga siendo libre de publicidad. Esta suscripción no cuenta con los beneficios de la suscripción 'Premium'.
  
Pagá una vez por mes. Cancelá cuando quieras.
  
  `,
  premium_plan: "Plan Premium: ",
  premium_plan_description: `La suscripción 'Premium' cuenta con las siguientes funcionalidades:
  
  `,
  premium_plan_body_1:
    "Cargar imágenes adicionales para tus álbumes usando la galería de imágenes.",
  premium_plan_body_2: `Usar imágenes de Discogs al importar álbumes.
  
  `,
  premium_plan_end: "Pagá una vez por mes. Cancelá cuando quieras.",
  access: `
  
Para acceder al estado de tu suscripción actual o comprar otra suscripción, podés ir a tu perfil de usuario.
  
`
};
